module.exports = __webpack_public_path__ + "img/24.e6fb8f0e.jpeg";